import { BasicSearchChangeHelper } from "./BasicSearchHelper.js";
import { MainSearchData } from "../searchData/MainSearchData.js";
import { MainMySearchHelper } from "../mySearchHelper/MainMySearchHelper.js";

export class MainSearchChangeHelper extends BasicSearchChangeHelper {
    constructor() {
        super();
        this.srchData = new MainSearchData();
    }

    async init() {
        await this.config.ensureLoaded();
        this.MySearchHelper = new MainMySearchHelper(this);
        return this;
    }

    // 주소선택-지역 정보 로드
    loadAdrs(obj, value) {
        let cd;

        // obj validation
        if (obj === "sido") {
            $("#guCd").children("option:not(:first)").remove();
            $("#dnCd").children("option:not(:first)").remove();
            cd = "siCd=" + value;
            this.srchData.siCd = parseInt(value);
            this.srchData.guCd = 0;
            this.guGunData = [];
            this.srchData.dnCd = 0;
            this.dongData = [];
        }
        if (obj === "gugun") {
            $("#dnCd").children("option:not(:first)").remove();
            cd = "siCd=" + this.srchData.siCd + "&guCd=" + value;
            this.srchData.guCd = parseInt(value);
            this.srchData.dnCd = 0;
            this.dongData = [];
        }
        if (obj === "dong") {
            this.srchData.dnCd = parseInt(value);
            return this;
        }

        $.ajax({
            type: 'POST',
            url: "/res/common.php?reqCase=adrsStep&"+cd,
            dataType: 'JSON',
            async: false,
        }).done((response) => {
            if (obj === "sido") {
                this.guGunData = response;
                this.wrapGuGunData();
            } else if(obj === "gugun" && parseInt(value) !== 0) {
                this.dongData = response;
                this.wrapDongData();
            }
        })
        .fail((jqXHR, textStatus, errorThrown) => {
            const response = jqXHR.responseJSON;
            alert(response.msg);
        });
        return this;
    }

    wrapGuGunData() {
        let div = "";
        $.each(this.guGunData, (index, item) => {
            div += `
                <option value='${item.guCd}'>
                    ${item.guNm}
                </option>
            `;
        });
        $("#guCd").append(div);
    }

    wrapDongData() {
        let div = "";
        $.each(this.dongData, (index, item) => {
            div += `
                <option value='${item.dnCd}'>
                    ${item.dnNm}
                </option>
            `;
        });
        $("#dnCd").append(div);
    }

    //종별-복수선택 보임/숨김
    showMainCtgrMulti(target) {
        this.autoAllCtgr();
        $("#trCtgrMulti").css("display", "");
        $(".moreFilter").css("display", "none");
    }

    hideMainCtgrMulti() {
        this.autoAllCtgr();
        $("#trCtgrMulti").css("display", "none");
        $(".moreFilter").css("display", "flex");
    }

    // 종별 - 전체선택
    chkCtgrAll(checked) {
        if(checked) {
            this.srchData.chkAllCtgr = 1;
            this.srchData.chkCtgrsCd = [];
            $("input:checkbox[name=chkEaCtgr]").prop("checked", false);
            $("input:checkbox[name=chkGrpCtgr]").prop("checked", false);
            return this;
        } else {
            this.hideMainCtgrMulti();
        }
        return this;
    }

    //종별-복수선택 제어
    chkCtgrMulti(id, checked) {
        // id값은 "chkGrpPrp_k" 형태로 들어옵니다. k를 추출합니다.
        const k = parseInt(id.split("_")[1]);
        // 하위요소는 ulGrpPrp_k div의 자식요소인 input:checkbox입니다. 그룹의 checked값과 동일하게 설정합니다.
        var ulObj = $("#ulGrpCtgr_" + k);
        $(ulObj.find("input:checkbox")).prop("checked", checked);

        return this.updateTotalCtgr(checked);
    }

    /**
     * 그룹단위로 체크박스가 변경될 때 모든 체크박스의 체크여부를 확인하여 검색조건을 변경합니다.
     * @returns {object} - 업데이트된 basicSearchChangeHelper 객체를 반환합니다.
     * */
    updateTotalCtgr() {
        // 검색조건을 초기화합니다.
        this.srchData.chkCtgrsCd = [];
        // chkPrps의 모든 check된 값을 가져와서 배열에 담습니다.
        let count = 0;
        $("input:checkbox[name=chkEaCtgr]").each((key, item) => {
            if (!item.id.includes('_side') && item.checked) {
                this.srchData.chkCtgrsCd.push(item.value);
                count++;
            }
        });
        $("#CategoryCount").text(count);
        this.autoAllCtgr();
        return this;
    }

    // 물건종별 복수개수를 확인, 전체선택 클릭여부 결정
    autoAllCtgr() {
        // 모든선택이 false경우 특수조건을 적용안함으로 변경합니다.
        if(this.srchData.chkCtgrsCd.length === 0) {
            this.srchData.chkAllCtgr = 1;
            $("#chkAllCtgr").prop("checked", true);
        } else {
            this.srchData.chkAllCtgr = 0;
            $("#chkAllCtgr").prop("checked", false);
        }
    }

    //물건종별 선택(단일)
    chkCtgrSingle(value, checked, groupKey) {
        if(checked) {
            // 체크되어있으면 추가
            this.srchData.chkCtgrsCd.push(value);
        } else {
            // 아니면 삭제합니다.
            this.srchData.chkCtgrsCd = this.srchData.chkCtgrsCd.filter((v) => v !== value);
        }
        // 모든선택이 false경우 특수조건을 적용안함으로 변경합니다.
        this.checkGroupKey (groupKey, "GrpCtgr");
        return this.updateTotalCtgr(checked, groupKey);
    }

    // 그룹키 체크
    checkGroupKey(groupKey, prefix) {
        if(groupKey > 0) {
            var ulObj = $(`#ul${prefix}_${groupKey}`);
            // ulObj의 모든 하위 체크박스가 체크되어있는지 확인합니다.
            const allChecked = $(ulObj.find("input:checkbox")).toArray().every((item) => item.checked);
            if(allChecked) {
                // 모두 체크되어있으면 그룹 체크박스도 체크합니다.
                $(`#chk${prefix}_${groupKey}`).prop("checked", true);
            } else {
                // 아니면 그룹 체크박스도 체크를 해제합니다.
                $(`#chk${prefix}_${groupKey}`).prop("checked", false);
            }
        }
    }
}